/*
 * @author BSG <dev@bsgroup.eu>
 * @copyright Better Software Group S.A.
 * @version: 1.0
 */

import { ActiveSubscriptionsContainer } from "./components";
import { useUserSubscriptions } from "hooks";
import dynamic from "next/dynamic";

const NoSubscriptionsContainer = dynamic(
  () => import("components/Settings/NoSubscriptionContainer")
);

import { CommonTextError } from "../../CommonTextError";

export const SettingsSubscription = () => {
  const { subscriptions, error } = useUserSubscriptions();

  if (error) {
    return <CommonTextError translationKey="web_my_account_error" />;
  }

  if (!subscriptions?.length) {
    return <NoSubscriptionsContainer />;
  }

  return (
    <>
      <ActiveSubscriptionsContainer subscriptions={subscriptions} />
    </>
  );
};

export default SettingsSubscription;
